import { HoverMenu, HoverMenuContent, HoverMenuItem, HoverMenuTrigger } from "@/app/common/common-components/ui/HoverMenu";
import { BookUser, Calendar, House, KanbanSquare, Newspaper, Star } from "lucide-react";
import { ReactNode, useState } from "react";
import { useNavigate } from "react-router";
import { MODULES } from "@/app/lib/constants";
import { cn } from "@/app/common/common-functions/functions";

type NewMenuProps = {
  children: ReactNode;
  onNewEventClick?: () => void;
  onNewDealClick?: () => void;
  modules?: number[];
  isAdmin?: boolean;
};

const NewMenu = ({ children, onNewEventClick, onNewDealClick, modules, isAdmin }: NewMenuProps) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const hasDealTracker = !!modules?.includes(MODULES.DEAL_TRACKER);

  return (
    <>
      <HoverMenu open={open} onOpenChange={setOpen} openDelay={0} closeDelay={100}>
        <HoverMenuTrigger
          asChild
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setOpen(true);
          }}
        >
          {children}
        </HoverMenuTrigger>
        <HoverMenuContent side="bottom" align="start" sideOffset={0} className="tw-rounded-t-none">
          <HoverMenuItem className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2" onClick={() => navigate("/Property/SaveProperty")}>
            <House className="tw-size-4" />
            Listing
          </HoverMenuItem>
          <HoverMenuItem className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2" onClick={() => navigate("/Contacts/SaveContact")}>
            <BookUser className="tw-size-4" />
            Contact
          </HoverMenuItem>
          {!!isAdmin && (
            <HoverMenuItem className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2" onClick={() => navigate("/Library/SaveContent")}>
              <Newspaper className="tw-size-4" />
              News
            </HoverMenuItem>
          )}
          <HoverMenuItem className="tw-flex tw-cursor-pointer tw-items-center tw-gap-2" onClick={onNewEventClick}>
            <Calendar className="tw-size-4" />
            Activity
          </HoverMenuItem>
          <HoverMenuItem
            className={cn("tw-flex tw-cursor-pointer tw-items-center tw-gap-2", !hasDealTracker && "tw-opacity-80")}
            onClick={() => {
              setOpen(false);
              onNewDealClick?.();
            }}
          >
            <KanbanSquare className="tw-size-4" />
            Deal
          </HoverMenuItem>
        </HoverMenuContent>
      </HoverMenu>
    </>
  );
};

export default NewMenu;
